import * as service from './service'
export default {
  namespace: 'recruitJumpQueue',
  state: {
    demoData: {}
  },
  effects: {
    * info ({ payload }, { call, put }) {
      const res = yield call(service.info, payload)
      return res.data
    },
    * createOrder ({ payload }, { call, put }) {
      const res = yield call(service.createOrder, payload)
      return res.data
    },
    * getRightsInfo ({ payload }, { call, put }) {
      const res = yield call(service.getRightsInfo, payload)
      return res.data
    },
    * detail ({ payload }, { call, put }) {
      const res = yield call(service.detail, payload)
      return res.data
    }

  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
